module.exports = __webpack_public_path__ + "static/img/ball5_new.0423103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ball5_new.png
// module id = zbRb
// module chunks = 1